import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=72a2ffd0"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports